export const removeListLanguages = (list) => [list[0], list[1], list[2], list[3]];
